import{remove}from"ts-invariant/process/index.js";import{Source}from"graphql";export function removeTemporaryGlobals(){return remove()}